import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UI = {
  isShowFooterPopUp: boolean;
  isShowJoinToSpacePopup: boolean;
  shouldInitPubnub: boolean;
  isShowShares: boolean;
};

const initialState: UI = {
  isShowFooterPopUp: false,
  shouldInitPubnub: false,
  isShowJoinToSpacePopup: false,
  isShowShares: false,
};

export const ui = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsShowFooterPopUpOverlay: (state, action: PayloadAction<boolean>) => {
      state.isShowFooterPopUp = action.payload;
    },
    setIsShowJoinToSpacePopup: (state, action: PayloadAction<boolean>) => {
      state.isShowJoinToSpacePopup = action.payload;
    },
    setIsShowShares: (state, action: PayloadAction<boolean>) => {
      state.isShowShares = action.payload;
    },
    setShouldInitPubnub: (state, action: PayloadAction<boolean>) => {
      state.shouldInitPubnub = action.payload;
    },
  },
});

export const { setIsShowFooterPopUpOverlay, setIsShowJoinToSpacePopup, setIsShowShares, setShouldInitPubnub } =
  ui.actions;
export default ui.reducer;
